import React from 'react';
import { Row, Col, Button, CardDeck } from 'react-bootstrap';
import Article from './Article/Article';
import { Link } from 'gatsby';
import './Blogs.css';
import { useContext } from 'react';
import { DataContext } from '../Layouts';
const Blogs = () => {
    const {allBlogs} = useContext(DataContext);
    const blogs = allBlogs.filter(blog => 'featured' in blog);
    return (
        <section className="pt-5">
            <Row>
                <Col md={7}>
                    <div className="section-title">
                    <h2 className="section-title"><span className="text-green">Some of</span>My Article</h2>
                        <div className="action text-right">
                            <Link class="details-link" to="/blog">
                                <Button variant="outline-success" size="sm">All Article</Button>
                            </Link>
                        </div>
                    </div>
                </Col>
            </Row>
            
            <CardDeck className="blogs my-5">
                {
                    blogs.map((blog,index) =>  <Article key={index} blog={blog} />)
                }
            </CardDeck>
        </section>
    );
};

export default Blogs;